<template>
  <v-container fluid>
  <v-form
      ref="formL"
      v-model="validL"
      lazy-validation
      v-if="languageData.loginForm && languageData.labels"
  >
    <div class="d-flex justify-center">
      <div class="flex-column login-form-wrapper">
        <v-col>
          <p class="login-slogan display-2 text-center font-weight-medium my-10">{{ languageData.loginForm.head }}</p>
        </v-col>
        <v-col>
          <v-text-field
              v-model="data.email"
              :rules="this.rules.email"
              light
              id="email"
              ref="email"
              autocomplete="on"
              single-line
              :label="languageData.labels.email"
              required
          ></v-text-field>
          <v-text-field
              light
              autocomplete="on"
              v-model="data.password"
              :rules="this.rules.password"
              id="password"
              ref="password"
              single-line
              type="password"
              :label="languageData.labels.password"
              required
          ></v-text-field>
        </v-col>
        <v-col class="d-flex flex-column justify-space-between">
          <v-btn
              class="text-capitalize"
              large
              color="primary"
              :loading="loginIsFetching"
              @click="login">
            {{ languageData.loginForm.btnText }}
          </v-btn>
          <v-col>
            <a href="/user/password/forget" style="text-decoration: none">
              <v-btn
                  large
                  text
                  class="text-capitalize primary--text">
                {{ languageData.loginForm.forgetPassword  }}
              </v-btn>
            </a>
          </v-col>
        </v-col>
      </div>
    </div>
  </v-form>
    <ModalInfo :typeInfo="modalData.typeInfoLogin" :headModal="modalData.headInfoLogin" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModal" :show-modal="isUserLogin" :text-modal="modalData.textInfoLogin"></ModalInfo>
    <ModalInfo :typeInfo="modalSaveInfoData.typeInfo" :headModal="modalSaveInfoData.head" :btnAgreeText="languageData.btnAgreeText" :visDisAgreeBtn="false" @clicked="hideModalResetPassword" :show-modal="isShowSaveModalInfo" :text-modal="modalSaveInfoData.textInfo"></ModalInfo>
  </v-container>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
  import eventBus from "../../../../event-bus/eventBus";
  import handleFormError from "../../../../helpers/handleFormError";

  export default {
    created() {
      eventBus.$on('failureLogin', (errorsData) => {
        this.rules = handleFormError(errorsData);
        this.$refs.formL.validate();
      });
      if(localStorage.getItem("textSave")) {
        this.modalSaveInfoData.typeInfo = "success";
        this.modalSaveInfoData.textInfo = localStorage.getItem("textSave");
        this.modalSaveInfoData.head = localStorage.getItem("messageSave");
        this.isShowSaveModalInfo = true;
        localStorage.removeItem("textSave");
        localStorage.removeItem("messageSave");
      }
      eventBus.$on("resetFormValidation", this.resetForm);
    },
    name: "LoginForm",
    data() {
      return {
        data: {},
        validL: false,
        rules: {},
        isShowSaveModalInfo: false,
        modalSaveInfoData: {},
      }
    },
    components: {
      ModalInfo
    },
    computed: {
      ...mapState('loginMain', {
        loginIsFetching: state => state.isFetching,
        modalData: state => state.modalData,
        isUserLogin: state => state.isUserLogin
      })
    },
    methods: {
      ...mapActions('loginMain', ['loginUser', 'updateVisibleModal']),
      login: function() {
        this.data.btnAgreeText = this.languageData.btnAgreeText;
        this.data.language = localStorage.getItem("language");
        this.rules = [];
        this.$refs.formL.resetValidation();
        this.loginUser({ creds: this.data });
      },
      hideModal: function() {
        this.updateVisibleModal(false);
      },
      hideModalResetPassword: function() {
        this.isShowSaveModalInfo = false;
      },
      resetForm: function() {
        this.$refs.formL.resetValidation();
      },
    },
  }
</script>
